module.exports = __webpack_public_path__ + "static/media/phone.f1901750.svg";